/**
 *
 */
export enum ScrollDirectionEnum {
  DOWN,
  UP
}
